import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <h1 className='m-0 mb-32 reveal-from-bottom center-content'>
            Our <span className='text-color-primary'>Programs</span>
          </h1>
          <div className={splitClasses}>
            <div className='split-item'>
              <div
                className='split-item-content center-content-mobile reveal-from-left'
                data-reveal-container='.split-item'
              >
                <div className='text-xxs text-color-secondary fw-600 tt-u mb-8'>
                  Student Loanership Program
                </div>
                <h3 className='mt-0 mb-12'>Pay Your Tuition Inc.</h3>
                <p className='m-0'>
                  Pay Your Tuition Funds (PYT) connects families and banks to
                  provide innovative solutions to finance higher education. We
                  believe that technology and data can unlock new solutions to
                  bridge the higher education funding gap.
                </p>
                <a
                  target='blank'
                  style={{ marginTop: '20px' }}
                  href='https://gopyt.com/'
                  className='button button-secondary button-wide-mobile button-sm'
                >
                  Learn More
                </a>
              </div>
              <div
                className={classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container='.split-item'
              >
                <Image
                  src={require('./../../assets/images/pyt.png')}
                  alt='Features split 01'
                  width={528}
                  height={320}
                />
              </div>
            </div>

            <div className='split-item'>
              <div
                className='split-item-content center-content-mobile reveal-from-right'
                data-reveal-container='.split-item'
              >
                <div className='text-xxs text-color-secondary fw-600 tt-u mb-8'>
                  Childcare Services
                </div>
                <h3 className='mt-0 mb-12'>GoAssistU</h3>
                <p className='m-0'>
                  AssiStu is a marketplace that connects college parents seeking
                  child care services with college students and other primary
                  care givers seeking employment. Low income college parents may
                  also be eligible for funding to help cover child care related
                  expenses.
                </p>
                <a
                  target='blank'
                  style={{ marginTop: '20px' }}
                  href='https://goassistu.com/'
                  className='button button-secondary button-wide-mobile button-sm'
                >
                  Learn More
                </a>
              </div>
              <div
                className={classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container='.split-item'
              >
                <Image
                  src={require('./../../assets/images/goassistu.png')}
                  alt='Features split 02'
                  width={528}
                  height={320}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
